import { NOOP as s } from "./index575.js";
const e = (t, o) => {
  if (t.install = (l) => {
    for (const n of [t, ...Object.values(o ?? {})])
      l.component(n.name, n);
  }, o)
    for (const [l, n] of Object.entries(o))
      t[l] = n;
  return t;
}, r = (t, o) => (t.install = (l) => {
  t._context = l._context, l.config.globalProperties[o] = t;
}, t), i = (t) => (t.install = s, t);
export {
  e as withInstall,
  r as withInstallFunction,
  i as withNoopInstall
};
